import React from 'react';

export const truncateWord = (word, truncateLength, ending = '...') =>
  word.length > truncateLength
    ? word.substring(0, truncateLength - ending.length) + ending
    : word;

export const useWindowScrollYIsGreaterThanEqual = size => {
  const [isGreaterThan150, update] = React.useState(true);
  const setLogoSize = () => {
    if (window.scrollY >= size) {
      update(false);
    } else {
      update(true);
    }
  };
  React.useEffect(() => {
    window.addEventListener('scroll', setLogoSize);
  });

  return isGreaterThan150;
};
